const ProfileSite = require("@/modules/users/components/ProfileSite").default;
const ProfileEdit = require("@/modules/users/components/ProfileEdit").default;
const FriendsSite = require("@/modules/users/components/FriendsSite.vue")
  .default;
const FriendRequestSite = require("@/modules/users/components/FriendRequestSite.vue")
  .default;

const UserRoutes = [
  {
    name: "Profile Own",
    path: "/profile",
    component: ProfileSite,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Profile Edit",
    path: "/profile-edit",
    component: ProfileEdit,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Profile",
    path: "/profile/:id",
    components: { default: ProfileSite },
    meta: {
      requiresAuth: true,
    },
    props: { default: true },
  },
  {
    name: "Friends",
    path: "/friends/",
    component: FriendsSite,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "Friend request",
    path: "/friend-request/:id",
    components: { default: FriendRequestSite },
    props: { default: true },
    meta: {
      requiresAuth: true,
    },
  },
];

const UserSettingsRoutes = [];

const UserBaseDataRoutes = [];

export { UserRoutes, UserSettingsRoutes, UserBaseDataRoutes };
